import { createPinia, PiniaPluginContext } from 'pinia';

const pinia = createPinia();

type PercistDelegate = (type: 'save' | 'load', store: unknown, state: unknown) => void;

type BootstrapDelegate = {
  storeId: string;
  percist: PercistDelegate;
};

const mutations: BootstrapDelegate[] = [];

pinia.use((context: PiniaPluginContext) => {
  const { store } = context;

  mutations.forEach(delegate => {
    if (store.$id === delegate.storeId) {
      delegate.percist('load', store, null);
    }
  });

  store.$subscribe((mutation, state) => {
    mutations.forEach(delegate => {
      if (mutation.storeId === delegate.storeId) {
        delegate.percist('save', null, state);
      }
    });
  });
});

export function bootstrap(storeId: string, percist: PercistDelegate) {
  mutations.push({
    storeId,
    percist,
  });
}

export { pinia };
